import {
  SHStack,
  SHToggleButtonOptions,
  SHTypography,
} from "@components/design-systems";
import { Box, Fade } from "@mui/material";
import { MaximumProductInAppendixTable } from "@pages/platform-analysis-v2/_id/constants";
import { isNil } from "lodash";

export const AppendixFeatureAnalysisSectionTitle = ({
  index = 0,
  showAppendixFeatureAnalysis = true,
  total,
  disabled,
  onChange,
}: {
  total: number;
  index?: number;
  showAppendixFeatureAnalysis?: boolean;
  disabled?: boolean;
  onChange?: (isShow: boolean) => void;
}) => {
  const maximumProductInTable = MaximumProductInAppendixTable;

  return (
    <>
      <SHStack flexDirection={"row"} gap={"5px"}>
        <SHTypography variant="subtitle2">
          Feature review{" "}
          <Box component="span" fontWeight={400}>
            of platforms that were not selected{" "}
          </Box>
          <Fade
            in
            timeout={500}
            key={showAppendixFeatureAnalysis ? "appendix" : "total"}
          >
            <Box component="span" fontWeight={400}>
              {showAppendixFeatureAnalysis ? (
                <>
                  (Platform {index * maximumProductInTable + 1}-
                  {Math.min(
                    index * maximumProductInTable + maximumProductInTable,
                    total,
                  )}{" "}
                  of {total})
                </>
              ) : (
                <>
                  (Total {total} platform{total > 1 && "s"})
                </>
              )}
            </Box>
          </Fade>
        </SHTypography>
      </SHStack>
      {!index && (
        <SHToggleButtonOptions
          disabled={disabled}
          options={[
            {
              label: "Show",
              value: "true",
            },
            {
              label: "Hide",
              value: "false",
            },
          ]}
          value={showAppendixFeatureAnalysis.toString()}
          onChange={(_, value: string) => {
            if (onChange && !isNil(value)) onChange(value === "true");
          }}
        />
      )}
    </>
  );
};
